import { createRouter } from '@tanstack/react-router';

import { DefaultCatchBoundary } from './components/DefaultCatchBoundary';
import { NotFoundContent } from './routes/404';
import { routeTree } from './routeTree.gen';
import { DEFAULT_LOCALE, type AppLocale } from './utils/i18n';

export interface RouterContext {
  locale: AppLocale;
}

export function getRouter() {
  return createRouter({
    routeTree,
    defaultPreload: 'intent',
    defaultErrorComponent: DefaultCatchBoundary,
    defaultNotFoundComponent: () => <NotFoundContent />,
    scrollRestoration: true,
    context: {
      locale: DEFAULT_LOCALE,
    } satisfies RouterContext,
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
